/**
 * Página de inicio del panel según el rol (spec 007-dashboard-impacto, US6)
 *
 * - Propietario y gerente (manager): Dashboard.
 * - Personal (staff): Órdenes. Los iPads de sala usan cuentas de personal.
 */

import type { AdminRole } from '@/types/admin';

export const DASHBOARD_PATH = '/admin/dashboard';
export const ORDERS_PATH = '/admin/orders';

export function adminHomePath(role: AdminRole | undefined | null): string {
  return role === 'owner' || role === 'manager' ? DASHBOARD_PATH : ORDERS_PATH;
}
